import {
  Card,
  CardContent,
  Divider,
  Grid,
} from "@material-ui/core";
import { BootstrapBadge } from "components/ui/BootstrapBadge";

import React, { useState } from "react";
// import ReactTable from "react-table-6";
import {toastSuccess, toastWarning } from "shared/utils";
import CheckbokKisshtTable from "components/table/CheckbokKisshtTable";
import KisshtButton from "components/ui/KisshtButton";
import { PERMISSIONS, ROUTE_NAME } from "shared/constants";
import { ConfirmDialog } from "components/ui/ConfirmDialog";
import { removeDepositPayment } from "shared/api/deposit";
import AddDepositPayment from "../dialogs/addDepositPayment";

const columns = [
  {
    Header: "User Reference No",
    accessor: "user_reference_number",
    sortable: false,
    filterable: false,
  },
  {
    Header: "Payment Reference No",
    accessor: "payment_reference_number",
    sortable: false,
    filterable: false,
  },
  {
    Header: "Payment Amount",
    accessor: "payment_amount",
    sortable: true,
    filterable: false,
  },
  {
    Header: "Cash Status",
    accessor: "Cash_status",
    sortable: false,
    filterable: false,
  },
  {
    Header: "Cash Collected Time",
    accessor: "cash_collected_date",
    sortable: true,
    filterable: false,
  },
  {
    Header: "Cash Collected Name",
    accessor: "cash_collected_name",
    sortable: false,
    filterable: false,
  },
  {
    Header: "Payment Status",
    accessor: "payment_status",
    sortable: true,
    filterable: false,
    Cell: (cell) => {
      return <BootstrapBadge text={cell.value} />;
    },
  },
  {
    Header: "Comment",
    accessor: "comment",
    sortable: false,
    filterable: false,
  },
  {
    Header: "Deposit Receive Date ",
    accessor: "deposit_receive_date",
    sortable: true,
    filterable: false,
  },
];

function DepositPaymentList({ data, deposit_ref_no, deposit_by_ref }) {
  const [selected, setSelected] = useState([]);
  const [removepaymentDialog, setRemovepaymentDialog] = useState(false);
  const [showAddPaymentModal, setshowAddPaymentModal] = useState(false);
  const handleSelect = (row, checked) => {
    if (checked === undefined) {
      setSelected(row);
      return false;
    }

    if (checked) {
      setSelected([...selected, row.original]);
    } else {
      let newselected = selected.filter(
        (value) =>
          row.original.user_reference_number !== value.user_reference_number
      );
      setSelected(newselected);
    }
  };

  const removehandler = async (e) => {
    e.preventDefault();
    if (!selected.length) return false;
    try {
      let payments = selected.map((value) => value.payment_reference_number);
      const res = await removeDepositPayment(
        deposit_ref_no,
        payments.join(",")
      );
      if (res.success) {
        toastSuccess(res.message);
        setTimeout(() => {
          document.location.reload();
        }, 1000);
      } else {
        toastWarning(res.message);
      }
    } catch (error) {}
  };

  const handleAddPaymentModal = (sts) => {
    if (sts) {
      setTimeout(() => {
        document.location.reload();
      }, 1000);
    }
    setshowAddPaymentModal(false);
  };
  return (
    <Card>
      <CardContent className="card-content_head">
        <Grid container alignItems="center" className="crum_padding">
          <Grid item lg={6} md={6} sm={6} xs={8}>
            Cash Paid Listing
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12} className='top_spacing_btn'>
            <Grid container spacing={1} alignItems="center" justifyContent="flex-end">
              {selected.length ? (
                <Grid item>
                  <KisshtButton
                    color="secondary"
                    route={ROUTE_NAME.deposit}
                    permission={PERMISSIONS.deposit.remove_payment}
                    onClick={() => setRemovepaymentDialog(true)}
                    className="common_kissht_btn"
                  >
                    Remove Payments
                  </KisshtButton>
                </Grid>
              ) : null}
              <Grid item>
                <KisshtButton
                  route={ROUTE_NAME.deposit}
                  permission={PERMISSIONS.deposit.add_payment}
                  onClick={setshowAddPaymentModal}
                  className="common_kissht_btn"
                >
                  Add Payment
                </KisshtButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <CheckbokKisshtTable
          // loading={spinning}
          columns={columns}
          data={data}
          handleSelect={handleSelect}
          selected={selected}
          checked={(row) => {
            return selected.find((value) =>
              Boolean(
                value.user_reference_number ===
                  row.original.user_reference_number
              )
            );
          }}
          // pageSize={10}
        />
      </CardContent>
      <ConfirmDialog
        open={removepaymentDialog}
        handleClose={(e) => setRemovepaymentDialog(false)}
        titleColor="red"
        title="Warning"
        message="Do you want to remove selected payments?"
        onAccept={removehandler}
        acceptText="remove"
      />
      {showAddPaymentModal && deposit_ref_no && (
        <AddDepositPayment
          visible={showAddPaymentModal}
          depositRef={deposit_ref_no}
          deposit_by_ref={deposit_by_ref}
          handleClose={handleAddPaymentModal}
        ></AddDepositPayment>
      )}
    </Card>
  );
}

export default DepositPaymentList;
